import { NotificationsDropdown } from '@iveco-ti/iveco-ds'
import { CheckCheck } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export function NotificationMenu() {
  const { t } = useTranslation('common')

  return (
    <NotificationsDropdown.Root
      tooltipText={t('authenticated_layout.notifications_dropdown.tooltip')}
    >
      <NotificationsDropdown.Header>
        <button className="text-sm font-semibold text-brand-900 text-center w-full hover:underline">
          {t('authenticated_layout.notifications_dropdown.button_header')}
        </button>
      </NotificationsDropdown.Header>

      <NotificationsDropdown.Body>
        <NotificationsDropdown.Empty
          title={t('authenticated_layout.notifications_dropdown.empty.title')}
          subTitle={t(
            'authenticated_layout.notifications_dropdown.empty.subTitle',
          )}
        />
      </NotificationsDropdown.Body>

      <NotificationsDropdown.Footer>
        <button
          className="flex items-center gap-2 text-sm text-base-400 text-center mx-auto w-fit not-disabled:hover:underline disabled:!cursor-not-allowed"
          disabled
        >
          <CheckCheck className="size-4" />
          {t('authenticated_layout.notifications_dropdown.button_footer')}
        </button>
      </NotificationsDropdown.Footer>
    </NotificationsDropdown.Root>
  )
}
